import React from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";

const ShowAlerte = ({ alerteSelected }) => {
  // console.log("alerteSelected: ", alerteSelected);
  let sortedData = alerteSelected;

  // Function to parse dates and handle nulls
  function parseDate(dateString) {
    return dateString ? new Date(dateString) : new Date(0); // Use epoch for null dates to sort them at the end
  }

  // Sort the data array
  try {
    sortedData = alerteSelected.sort((a, b) => {
      return parseDate(a.created_at) - parseDate(b.created_at);
    });
  } catch (error) {
    console.error("Erreur: ", error);
  }

  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  return (
    <ul
      className="list-unstyled chat-conversation-list"
      id="users-conversation"
    >
      {sortedData &&
        sortedData.map((alerte, key) => {
          const vehicleList = alerte.visibility
            ? alerte.visibility.split(";").map((item) => item.trim())
            : [];

          return (
            <li className={"chat-list right"} key={key}>
              <div className="conversation-list">
                <div className="user-chat-content">
                  <div className="ctext-wrap">
                    <div className="ctext-wrap-content">
                      <div className="flex-grow-1">
                        <p className="mb-0 ctext-content">{alerte.titre}</p>
                        <h5 className="conversation-name">{alerte.content}</h5>
                      </div>
                    </div>
                    <UncontrolledDropdown
                      className={`align-self-start message-box-drop ${
                        vehicleList.length === 0 && "d-none"
                      }`}
                    >
                      <DropdownToggle href="#" className="btn nav-btn" tag="a">
                        <i className="ri-eye-line"></i>
                      </DropdownToggle>
                      <DropdownMenu>
                        <PerfectScrollbar>
                          {vehicleList.map((vehicle, index) => (
                            <DropdownItem key={index}>{vehicle}</DropdownItem>
                          ))}
                        </PerfectScrollbar>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                  <div className="conversation-name">
                    <small className="text-muted time">
                      {alerte.created_at && formatDate(alerte.created_at)}
                    </small>
                    <span className="text-success check-message-icon">
                      <i className="ri-check-double-line align-bottom"></i>
                    </span>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
    </ul>
  );
};

export default ShowAlerte;
